import './ShopFollow.css'

export function ShopFollow({ showReview = true }) {
  return <aside className='shop-follow' aria-label='Магазин PAY2PLAY на Маркете'>
    <div className='shop-follow__text'>
      <h3>Оставайтесь с PAY2PLAY</h3>
      <p>Подпишитесь на магазин на Маркете.{showReview && ' А если уже получили покупку — поделитесь впечатлениями в отзыве.'}</p>
    </div>
    <div className='shop-follow__links'>
      <a href='https://market.yandex.ru/business--pay2play/152514373' target='_blank' rel='noopener noreferrer'>Подписаться на магазин <span aria-hidden='true'>↗</span></a>
      {showReview && <a href='https://market.yandex.ru/my/orders?filter=COMPLETED' target='_blank' rel='noopener noreferrer'>Оставить отзыв <span aria-hidden='true'>↗</span></a>}
    </div>
  </aside>
}
